export enum OperationsManagementReservoir {
  SLIDER = 'GESTIONOPERATIVA_Slider',
  MANUALES = 'GESTIONOPERATIVA_Manuales',
  CONCURSOS_PROGRAMAS = 'GESTIONOPERATIVA_ConcursosProgramas',
  BIBLIOTECA = 'GESTIONOPERATIVA_Biblioteca',
  CONCURSOS_PLAN_IMAGEN = 'GESTIONOPERATIVA_Concursos_PlanImagen',
  CONCURSOS_TYC = 'GESTIONOPERATIVA_Concursos_TyC',
  CONCURSOS_TYC_USUARIOS = 'GESTIONOPERATIVA_Concursos_TyC_Usuarios',
  ESTADISTICAS_CONCURSO_PROGRAMA = 'GESTIONOPERATIVA_Estadisticas_ConcursoPrograma',
  CATEGORIAS_MANUALES = 'GESTIONOPERATIVA_Categorias_Manuales',
  TARGET_ESPERADO = 'GESTIONOPERATIVA_TARGET_ESPERADO',
  ACCESOS_INTERES = 'GESTIONOPERATIVA_ACCESOS_INTERES',
  ACCESOS_INTERES_CONCURSOS = 'GESTIONOPERATIVA_ConcursoPrograma_Accesos',
  MYSTERY_HAB = 'GESTIONOPERATIVA_MYSTERY_HAB',
  ACCESOS_INTERES_GENERAL = 'GESTIONOPERATIVA_ConcursoPrograma_ACCESOS_INTERES',
}
